import Favorite from '@/js/plugins/CookieDb/Favorite';
import { requestFetch, authCheck } from '@/js/helpers';

const main = async () => {
    if (document.querySelector('.c-buttons-favorite') === null) return;
    const favorite = new Favorite();
    const target = authCheck() ? 'db' : 'cookie';

    document.querySelectorAll('.c-buttons-favorite').forEach(async (obj) => {
        const id = obj.dataset.id;

        // お気に入りボタンクリックアクション
        obj.addEventListener('click', async () => {
            if (!id) return;

            const prevState = obj.hasAttribute('data-active');
            const nextState = !prevState;
            if (nextState) {
                obj.dataset.active = '';
            } else {
                delete obj.dataset.active;
            }
            const resp = await favorite.setState(target, id, nextState);
            if (!resp) {
                if (prevState) {
                    obj.dataset.active = '';
                } else {
                    delete obj.dataset.active;
                }
            }
            favorite.getAll(target).then((favorites) => {
                if (document.querySelector('[data-favorite-count]')) {
                    document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
                        targetObj.textContent = favorites.length < 99 ? favorites.length : '99+';
                        targetObj.dataset.count = favorites.length;
                    });
                }

                // 同ページ内にあるお気に入りボタンのアクティブ反映
                if (document.querySelector(`[data-type="favorite"][data-id="${id}"]`)) {
                    document.querySelectorAll(`[data-type="favorite"][data-id="${id}"]`).forEach((targetObj) => {
                        if (nextState) {
                            targetObj.dataset.active = '';
                        }
                        else {
                            delete targetObj.dataset.active;
                        }
                    });
                }
            });
        });
    });

    // お気に入りボタン初期表示
    favorite.getAll(target).then((favorites) => {
        favorites.forEach((favorite) => {
            document.querySelectorAll('.c-buttons-favorite').forEach((obj) => {
                if (obj.dataset.id === favorite) {
                    obj.dataset.active = '';
                }
            });
        });
    });
}

export default main;
